import React, {useRef} from 'react';
import Carousel from "react-elastic-carousel";
import Stakeholder from "./components/stakeholder";
import useStakeholders from "../../../hooks/public/useStakeholders";

const Stakeholders = () => {
  const carouselRef = useRef(null);
  let resetTimeout;
  const breakPoints = [
    {width: 1, itemsToShow: 1},
    {width: 200, itemsToShow: 2},
    {width: 768, itemsToShow: 3},
    {width: 992, itemsToShow: 4},
    {width: 1125, itemsToShow: 5}
  ];
  const {data} = useStakeholders();

  return (
      <section className="stakeholder-section">
        <div className="custom-container">
          <header className="stakeholder-header">
            <h2 className="stakeholder-title">Stakeholders</h2>
          </header>
          <div className="stakeholder-body">
            <div className="owl-carousel-container">
              {data && data.length > 0 &&
                  <Carousel
                      id="stakeholderCarousel"
                      className="owl-carousel owl-theme"
                      breakPoints={breakPoints}
                      itemPadding={[0, 5]}
                      ref={carouselRef}
                      enableAutoPlay
                      pagination={false}
                      autoPlaySpeed={3000}
                      transitionMs={1500}
                      enableMouseSwipe={false}
                      onNextEnd={({index}) => {
                        clearTimeout(resetTimeout);
                        resetTimeout = setTimeout(() => {
                          carouselRef?.current?.goTo(0);
                        }, 4000);
                      }}
                  >
                    {data.map((stakeholder) => (
                        <Stakeholder key={stakeholder.id} stakeholder={stakeholder}/>
                    ))}
                  </Carousel>
              }
            </div>
          </div>
        </div>
      </section>
  );
};

export default Stakeholders;
